import type { FaireReviewEntity } from "../../entity_types/review";

// Real Softies review, read off the brand's public Faire product-reviews API
// (Ryan, 2026-09-02) — verbatim comment, real reviewer, real shop, real date.
// `review_sof*` prefix keeps these from colliding with another brand's files.
export const review_sofb2: FaireReviewEntity = {
  token: "review_sofb2",
  type: "review",
  brandName: "Softies",
  brandToken: "b_br6ji29u",
  reviewType: "brand",
  reviewerName: "Mandi",
  reviewerLocation: "Dallas, TX",
  stars: 5,
  reviewText: "Everything we've gotten from Softies has flown out the door. The quality, the price point and the overall look fits with our aesthetic perfectly, and our customers love it!",
  reviewDate: "Feb 21, 2025",
  purchasedProductTokens: [
    "p_jjcrjr276j",
    "p_zzwte273ph",
    "p_bekx8fcudn",
    "p_78fuujjdd3",
  ],
  meta: {
    source: "api",
    importedAt: "2026-09-02T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
